import { Component, Input } from '@angular/core';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ImageService } from 'src/app/shared/services/image.service';

@Component({
  selector: 'app-item-sm-tenant',
  template: `
    <div class="d-flex py-2 px-2">
      <div class="me-3">
        <img [src]="avatarURL" width="44" height="44" class="rounded-5 border border-2 shadow-sm">
      </div>
      <div class="mt-1">
        <h4 class="mb-0" style="font-size: 1.0em;">{{tenant.name}} {{tenant.last_name}}</h4>
        <p class="mb-0" style="font-size: 0.8em;">{{tenant.email}}</p>
      </div>
      <div class="ms-auto">
        <button type="button" class="btn btn-link pe-2 ps-0 mt-0 float-end" routerLink="/tenant/profile/{{tenant.id}}">
          <fa-icon [icon]="icons.faEdit"></fa-icon>
        </button>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ItemSmTenantComponent {
  @Input() tenant: any;

  avatarURL: string = '';

  constructor(
    public icons: IconsService,
    public images: ImageService
  ) { }

  ngOnInit(): void {
    this.loadAvatar();
  }

  loadAvatar() {
    let el = this.tenant.avatar;

    if (!el) {
      this.avatarURL = 'assets/images/avatar.png';
    } else {
      this.avatarURL = `${this.images.apiUrl}/storage/${el.key.substring(0,2)}/${el.key.substring(2,4)}/${el.key}`;
    }
  }
}
